import store from "@/store/store";
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import { ILanguageItem, IFooterAssets, IErrorText } from "@/interface";
import {
  getSiteAssets,
  getLanguageList
} from "@/api/index";
import { getNavigatorLang } from "@/utils/common";
import langCodeConfig from "@/config/lang";

@Module({
  dynamic: true,
  namespaced: true,
  name: "config",
  store
})
class ConfigModule extends VuexModule {
  /* state */

  /* eslint-disable */
  langSeled: ILanguageItem = {
    // 选中语言项
    is_language_open: true,
    lang: "",
    display_name: "",
    country_name: "",
    region_of_language: ""
  };
  
  ignoreOnbeforeunload = false;   // 忽略离开商店页面前提示

  /* eslint-enable */
  langCode: { [key: string]: string } = langCodeConfig // 浏览器语言代码对应国家代码
  langList: ILanguageItem[] = []; // 语言国家列表信息
  langLoading = false; // 国家列表加载中（默认false，initLang期间为true）

  gameId = sessionStorage.getItem("gameId") || ""; // 当前商店页面的游戏Id

  categoryForUserTermTitle?: string = ""; // 用户条款标题
  categoryForUserTermContent?: string = ""; // 用户条款内容
  categoryForPrivacyTermTitle?: string = ""; // 隐私策略标题
  categoryForPrivacyTermContent?: string = ""; // 隐私策略内容
  categoryForAgreementTitle?: string = ""; // 公司名
  categoryForAgreementContent?: string = ""; // 用户同意条款内容
  categoryForContactEmailTitle?: string = ""; // 联系邮箱标题
  categoryForContactEmailContent?: string = ""; // 联系邮箱地址
  categoryForUnderstoodTitle?: string = ""; // mask确认按钮文本
  categoryForFailText = ""; // 商店未开放文本

  categoryForError_USER_INVALID = ""; // 用户输入的是无效用户ID
  categoryForError_ITEM_INVALID = ""; // 用户选择的商品是无效商品
  categoryForError_SERVER_INVALID = ""; // 用户选择的是无效服务器
  categoryForError_SERVER_MAINTENANCE = ""; // 停机维护中无法充值
  categoryForError_SERVER_UNAVAILABLE = ""; // 其它未知原因导致游戏方接口调用失败
  categoryForError_DUPLICATE_PURCHASE = ""; // 用户重复购买了不能重复购买的商品
  categoryForError_USER_INELIGIBLE = ""; // 用户没有资格购买该商品
  categoryForError_ORDER_NOT_FOUND = ""; // 发货时未找到对应的订单号
  categoryForError_ERROR_INIT_TRANSACTION = ""; // 初始化交易时发生错误（比如第三方平台和当地运营商之间发生错误）
  categoryForError_INVALID_PARAMS = ""; // 调用接口时参数有错误（有Bug或者故意传错某些参数）
  categoryForError_UNKNOWN_ERROR = ""; // 未知错误（如：服务器、数据库出错）

  /* getter */
  get lang (): string {
    // 已选语言key值
    return this.langSeled.lang;
  }

  get formatRegionLangList () {
    // 格式化 语言列表 （按照地区来排）
    const displayList: { [key: string]: ILanguageItem[] } = { };
    for (const item of this.langList) {
      if (displayList[item.region_of_language]) {
        displayList[item.region_of_language].push(item);
      } else {
        displayList[item.region_of_language] = [item];
      }
    }

    const list = [];
    for (const key in displayList) {
      list.push({
        key,
        value: displayList[key]
      });
    }
    return list.sort((a, b) => a.key.localeCompare(b.key));
  }

  /* mutation */
  @Mutation
  setLangSeled (languageItem: ILanguageItem) {
    this.langSeled = languageItem;
    sessionStorage.setItem("lang", this.langSeled.lang);
  }

  @Mutation
  setLangList (langList: ILanguageItem[]) {
    this.langList = langList;
  }

  @Mutation
  setLangLoading (loading: boolean) {
    this.langLoading = loading;
  }

  @Mutation
  setIgnoreOnbeforeunload (ignore: boolean) {
    this.ignoreOnbeforeunload = ignore;
  }

  @Mutation
  setGameId (gameId: string) {
    this.gameId = gameId;
    sessionStorage.setItem("gameId", this.gameId);
  }

  @Mutation
  setFooterAssets (siteAssets: IFooterAssets) {
    this.categoryForUserTermTitle = siteAssets.categoryForUserTermTitle;
    this.categoryForUserTermContent = siteAssets.categoryForUserTermContent;
    this.categoryForPrivacyTermTitle = siteAssets.categoryForPrivacyTermTitle;
    this.categoryForPrivacyTermContent = siteAssets.categoryForPrivacyTermContent;
    this.categoryForAgreementTitle = siteAssets.categoryForAgreementTitle;
    this.categoryForAgreementContent = siteAssets.categoryForAgreementContent;
    this.categoryForContactEmailTitle = siteAssets.categoryForContactEmailTitle;
    this.categoryForContactEmailContent = siteAssets.categoryForContactEmailContent;
  }

  @Mutation
  setCategoryForFailText (failText: string) {
    this.categoryForFailText = failText;
  }

  @Mutation
  setMaskText (categoryForUnderstoodTitle: string) {
    this.categoryForUnderstoodTitle = categoryForUnderstoodTitle;
  }

  /* eslint-disable */
  @Mutation
  setCategoryForError (siteAssets: IErrorText) {
    this.categoryForError_USER_INVALID = siteAssets.categoryForError_USER_INVALID;
    this.categoryForError_ITEM_INVALID = siteAssets.categoryForError_ITEM_INVALID;
    this.categoryForError_SERVER_INVALID = siteAssets.categoryForError_SERVER_INVALID;
    this.categoryForError_SERVER_MAINTENANCE = siteAssets.categoryForError_SERVER_MAINTENANCE;
    this.categoryForError_SERVER_UNAVAILABLE = siteAssets.categoryForError_SERVER_UNAVAILABLE;
    this.categoryForError_DUPLICATE_PURCHASE = siteAssets.categoryForError_DUPLICATE_PURCHASE;
    this.categoryForError_USER_INELIGIBLE = siteAssets.categoryForError_USER_INELIGIBLE;
    this.categoryForError_ORDER_NOT_FOUND = siteAssets.categoryForError_ORDER_NOT_FOUND;
    this.categoryForError_ERROR_INIT_TRANSACTION = siteAssets.categoryForError_ERROR_INIT_TRANSACTION;
    this.categoryForError_INVALID_PARAMS = siteAssets.categoryForError_INVALID_PARAMS;
    this.categoryForError_UNKNOWN_ERROR = siteAssets.categoryForError_UNKNOWN_ERROR;
  }
  /* eslint-enable */

  /* action */

  /* eslint-disable */
  @Action({ rawError: true })
  async getSiteAssets (lang: string) {
    const getSiteAssetsRet: any = await getSiteAssets(lang);
    console.log("[getSiteAssetsRet]", getSiteAssetsRet);

    const siteAssets = getSiteAssetsRet.payload.siteAssets.data.asset;
    this.setCategoryForError(siteAssets);
    this.setFooterAssets(siteAssets);
    this.setMaskText(siteAssets.categoryForUnderstoodTitle);
    this.setCategoryForFailText(siteAssets.categoryForFailText);

    return getSiteAssetsRet;
  }
  /* eslint-enable */

  /* eslint-disable */
  @Action({ rawError: true })
  async initLang () {
    try {
      /* 获取语言列表 */
      const getLangListRet: any = await getLanguageList();
      console.log("[getLangListRet]", getLangListRet);
      let langList: ILanguageItem[] = getLangListRet.payload.data.languageList;
      /* 筛选公开语言列表 */
      langList = langList.filter((langItem: ILanguageItem)=> langItem.is_language_open)
      this.setLangList(langList);

      /* 根据浏览器首选语言设置当前语言 */
      if (langList.length > 0) {
        let searchLang = "";

        const storageLang = sessionStorage.getItem("lang");
        if (storageLang) {
          // 有缓存语言key值，直接使用
          searchLang = storageLang;
        } else {
          // 没有缓存语言key值，获取浏览器首选语言
          const userLang = getNavigatorLang();
          console.log("[userLang]:", userLang);
          if(this.langCode.userLang) {
            searchLang = this.langCode.userLang;
          } else if(this.langCode[userLang.split("-")[0]]) {
            searchLang = this.langCode[userLang.split("-")[0]]
          }
        }
        console.log("[searchLang]", searchLang)
        const filterRet = langList.find(langItem => langItem.lang === searchLang);
        console.log("[langList-filterRet]", filterRet)
        if (filterRet) {
          // 有匹配到相关地区
          this.setLangSeled(filterRet);
        } else {
          // 未匹配到相关地区，选择格式化地区列表后第一项
          this.setLangSeled(this.formatRegionLangList[0].value[0]);
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
   /* eslint-enable */
}

export default getModule(ConfigModule);
